import React, { useState, useEffect } from 'react';
import './Clock.css';

const Clock = ({ onFullscreenClick }) => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (date) => {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return (
      <>
        {hours}
        <span className="clock-colon">:</span>
        {minutes}
        <span className="clock-colon">:</span>
        {seconds}
      </>
    );
  };

  return (
    <div className="clock-container">
      <div className="clock-logo">
        <img src="/images/onetimer-logo.svg" alt="OneTimer" />
      </div>
      <div className="clock-display" onClick={onFullscreenClick}>
        {formatTime(time)}
      </div>
      <div className="clock-subtitle">
        Click on the clock to enter fullscreen
      </div>
    </div>
  );
};

export default Clock;